import React, { useEffect, useState, useRef, useCallback } from 'react';
import config from '../../config/config';
import { FormControlLabel, FormControl, RadioGroup, Radio, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import NumberFormat from 'react-number-format';
import '../../../styles/loanofficer-realestateagent.scss';
import CloseIcon from '@material-ui/icons/Close';

export default function LoanOfficer(props) {
    const ref = useRef()
    const [loanOfficer, setLoanOfficer] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isExists,setIsExists] = useState(true);
    const [loanOfficerValue, setLoanOfficerValue] = useState(null)

    const myDefaultOption = { calque_partner_contact_full_name: "+Add New", partner_contact_role: 1, calque_partner_contact_id: 0 };

    const phoneNumberFormat = (event) => {
        let brackets = event.target.value.replace(/[-()+]/g, '');
        let spaces = brackets.split(" ").join("");
        props.values.loan_officer_info.phone_number = spaces
    }
    const handleEmail = (e) => {
        props.values.loan_officer_info.email = e.target.value.replace(/\s/g, "");
    }
    const handleFirstName = (e) => {
        props.values.loan_officer_info.first_name = e.target.value
    }
    const handleLastName = (e) => {
        props.values.loan_officer_info.last_name = e.target.value
    }
    const resetInputField = () => {
        props.values.loan_officer = '';
        props.values.loan_officer_info.first_name = '';
        props.values.loan_officer_info.last_name = '';
        props.values.loan_officer_info.email = '';
        props.values.loan_officer_info.phone_number = null;
    };
    const resetAllInputField = () => {
        props.values.loan_officer = '';
        props.values.loan_officer_info.first_name = '';
        props.values.loan_officer_info.last_name = '';
        props.values.loan_officer_info.email = '';
        props.values.loan_officer_info.phone_number = null;
        props.setSelectedLo(null);
        props.setIsSelectedLo(false);
        props.setLoanOfficerSelected(null);
        props.setIsDisabledLo(false);
        setIsExists(true);
    };
    const handleSearchValue = (event) => {
        let partner_contact = props.partnerContactRole && props.partnerContactRole.find((res) => {
            if (res.partner_contact_role_name == "Loan Officer") {
                return res.partner_contact_role_id;
            }
        })
        if (event.target.value !== '+Add New ') {
            setLoanOfficerValue(event.target.value)
        }
        if (event.target.value.length > 0) {
            setIsLoading(true)
            fetch(`${props?.partner?.partner_id != null ? `${config.baseUrlCP}search-partner-contact?partner_id=${props?.partner?.partner_id}&partner_contact_role_id=${partner_contact?.partner_contact_role_id ? partner_contact?.partner_contact_role_id : null}&q=${event.target.value}` : `${config.baseUrlCP}get-calque-partner-contact?`}`,
                {
                    headers: {
                        "Authorization": `${process.env.REACT_APP_API_KEY}`,
                        'Accept-Encoding': 'gzip, deflate',
                    }
                })
                .then(async response => {
                    const result = await response.json();
                    let loanValue = [myDefaultOption];
                    
                    if (response.status === 201 || response.status === 200) {
                        if (result.length > 0) {
                            const filteredLoanOfficers = result.filter((item) => item.partner_contact_role === 1);
                            loanValue = [myDefaultOption, ...filteredLoanOfficers];
                        }
                    }
                    setLoanOfficer(loanValue);
                    setIsOpen(true);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setLoanOfficer([myDefaultOption]);
            setIsOpen(false);
            setIsLoading(false);
        }
    }
    const handleNotFound = () => {
        props.values.loan_officer = '+Add New';
        props.formik.setFieldValue('loan_officer', '+Add New')
        setLoanOfficerValue('+Add New');
        setIsOpen(false)
    }
    const handleCloseIcon = () => {
        setLoanOfficerValue(null)
        props.values.loan_officer = null;
        setLoanOfficer([])
        props.setIsDisabledLo(false)
        setIsOpen(false)
    }
    const debounce = (func) => {
        let timeoutId;
        return function (...args) {
            const context = this;
            if (debouncedSearch) clearTimeout(timeoutId);
            setLoanOfficer([])
            setIsLoading(true)
            timeoutId = setTimeout(() => {
                timeoutId = null
                func.apply(context, args);
            }, 1000);
        }
    };
    const handleChangeValue = (newValue) => {
        props.setSelectedLo(newValue);
        if (newValue === '+Add New'){
            props.setIsSelectedLo(true);
            setLoanOfficerValue('')
            resetInputField()
            setIsExists(false);
        }else if(newValue === null){
            props.setLoanOfficerSelected(null);
            if(props.loanOfficerSelected !== null){
                props.formik.setFieldValue('loan_officer_info.first_name', "")
                props.formik.setFieldValue('loan_officer_info.last_name', "")
            }
        }
        else{
            setIsExists(true);
            props.setIsSelectedLo(false);
            loanOfficer && loanOfficer.map(lo => {
                if (lo.calque_partner_contact_full_name === newValue) {
                    props.values.loan_officer = lo.calque_partner_contact_id;
                    props.formik.setFieldValue('loan_officer', lo.calque_partner_contact_id)
                    setLoanOfficerValue(lo.calque_partner_contact_full_name)
                    props.setLoanOfficerSelected(lo.calque_partner_contact_full_name);
                    setIsOpen(false)
                    props.setIsDisabledLo(true)
                }
            })
        }
    }
    const debouncedSearch = useCallback(
        debounce(handleSearchValue, 200),
        []
    );

    useEffect(() => {
        if (props.reset === true) {
            props.values.loan_officer_info.email = ''
        }
        if (props?.partner?.url_path !== 'jw&!$329654' && props?.partner?.url_path && (props.values.loan_officer === null || props.values.loan_officer === '' || props.values.loan_officer === 0)) {
            if ((props.values.loan_officer_info.first_name !== "" && props.values.loan_officer_info.first_name !== undefined) && (props.values.loan_officer_info.last_name !== "" && props.values.loan_officer_info.last_name !== undefined)) {
                props.values.loan_officer_info.email = props.values.loan_officer_info.first_name + props.values.loan_officer_info.last_name + "@" + props?.partner?.url_path + ".com"
            }
        }
    }, [props.values.loan_officer_info.first_name, props.values.loan_officer_info.last_name])
    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOpen(false)
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [isOpen])
    useEffect(() => {
        if (props.values.is_loan_officer == "false" || props.values.is_loan_officer == "") {
            setLoanOfficerValue(null)
            setIsExists(true)
            props.values.loan_officer = '';
            props.formik.setFieldValue('loan_officer', '')
        }
    }, [props.values.is_loan_officer])
    useEffect(() => {
        let res = loanOfficer && loanOfficer.filter(o => o.calque_partner_contact_id === props.values.loan_officer)
        if (res.length !== 0) {
            props.values.loan_officer_info.first_name = res[0].first_name;
            props.values.loan_officer_info.last_name = res[0].last_name;
            props.values.loan_officer_info.email = res[0].email;
            props.values.loan_officer_info.phone_number = res[0].phone_number;
        }
    }, [loanOfficerValue])

    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();
        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    return (
        <div>
            <h4 className="form-content-heading m-0">Are you working with a loan officer?</h4>
            <div className="py-2">
                <RadioGroup
                    row name="is_loan_officer"
                    style={{width: '150px'}}
                    value={props.values.is_loan_officer}
                    onClick={resetAllInputField}
                    onChange={props.handleChange}
                >
                    <div>
                        <FormControlLabel value="true" control={<StyledRadio />} label="Yes" />
                    </div>
                    <div>
                        <FormControlLabel value="false" control={<StyledRadio />} label="No" />
                    </div>
                </RadioGroup>
                {props.values.is_loan_officer === "true" ?
                    <div>
                        {props?.partner?.url_path &&
                            <div>
                                <div className='d-none d-md-block'>
                                    <FormControl variant="outlined" className="property-select w-50 px-3 py-2 pb-3">
                                        <Autocomplete
                                            disablePortal
                                            ref={ref}
                                            name="loan_officer"
                                            style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{ padding: '0px 20px'}}
                                            onChange={(event, newValue) => {
                                                props.handleChange(event);
                                                handleChangeValue(newValue);
                                            }}
                                            popupIcon={false}
                                            closeIcon={<CloseIcon onClick={handleCloseIcon} fontSize="small" />}
                                            open={isOpen}
                                            onChangeCapture={debouncedSearch}
                                            className="loan_officer_Search"
                                            loading={isLoading}
                                            noOptionsText={<div className="not_found" onClick={() => handleNotFound()} style={{backgroundColor: '#1169b0', color: '#fff', width: '100%', padding: '5px 10px'}}>+Add New</div>}
                                            options={loanOfficer && loanOfficer.map((lo) => lo.calque_partner_contact_full_name)} 
                                            value={props?.loanOfficerSelected ? props.loanOfficerSelected:loanOfficerValue}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Search Loan Officer"
                                                    margin="normal"
                                                    variant="outlined"
                                                    style={{ height: "52px", marginTop: '8px' }}
                                                    fullWidth
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        readOnly: props.isDisabledLo, 
                                                    }}
                                                />
                                            )}
                                            renderOption={(options) =>{
                                                return(<div style={{
                                                    backgroundColor: options === '+Add New'? "#1c79c3" : "",
                                                    color: options === '+Add New'? "#fff" : "",
                                                    width: "100%",
                                                    padding: '5px 10px'
                                                }}>
                                                    {options}
                                                </div>)
                                            }}
                                        />
                                    </FormControl>
                                </div>
                                <div className='d-block d-md-none'>
                                    <FormControl variant="outlined" className="property-select pl-3 w-100 pb-3">
                                        <Autocomplete
                                            disablePortal
                                            ref={ref}
                                            name="loan_officer"
                                            style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{ padding: '0px 20px'}}
                                            onChange={(event, newValue) => {
                                                props.handleChange(event);
                                                handleChangeValue(newValue);
                                            }}
                                            popupIcon={false}
                                            closeIcon={<CloseIcon onClick={handleCloseIcon} fontSize="small" />}
                                            open={isOpen}
                                            onChangeCapture={debouncedSearch}
                                            className="loan_officer_Search"
                                            loading={isLoading}
                                            noOptionsText={<div className="not_found" onClick={() => handleNotFound()} style={{backgroundColor: '#1169b0', color: '#fff', width: '100%', padding: '5px 10px'}}>+Add New</div>}
                                            options={loanOfficer && loanOfficer.map((lo) => lo.calque_partner_contact_full_name)} 
                                            value={props?.loanOfficerSelected ? props.loanOfficerSelected:loanOfficerValue}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Search Loan Officer"
                                                    margin="normal"
                                                    variant="outlined"
                                                    style={{ height: "52px", marginTop: '8px' }}
                                                    fullWidth
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        readOnly: props.isDisabledLo,
                                                    }}
                                                />
                                            )}
                                            renderOption={(options) =>{
                                                return(<div style={{
                                                    backgroundColor: options === '+Add New'? "#1c79c3" : "",
                                                    color: options === '+Add New'? "#fff" : "",
                                                    width: "100%",
                                                    padding: '5px 10px'
                                                }}>
                                                    {options}
                                                </div>)
                                            }}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        }
                        {!isExists || props.isSelectedLo ?
                            <div className="pt-2 form-content-field">
                                <div className="py-2">
                                    <div className="w-res-50 py-2 d-sm-flex">
                                        <div className="col-12 col-sm-6 pl-sm-0 pr-sm-2 p-0">
                                            <div className="pb-2">
                                                <h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>First Name<span className="red-color">*</span></h6>
                                            </div>
                                            <div>
                                                <TextField
                                                    type="text"
                                                    id="customer_first_name"
                                                    variant="outlined"
                                                    name="loan_officer_info.first_name"
                                                    className="form-TextField"
                                                    onBlur={(e) => (handleFirstName(e))}
                                                    onChange={props.handleChange}
                                                    value={props.values.loan_officer_info.first_name?.trimStart()}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 pr-sm-0 pl-sm-2 p-0 pt-3 pt-sm-0">
                                            <div className="pb-2">
                                                <h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Last Name<span className="red-color">*</span></h6>
                                            </div>
                                            <div>
                                                <TextField
                                                    type="text"
                                                    id="customer_last_name"
                                                    variant="outlined"
                                                    name="loan_officer_info.last_name"
                                                    className="form-TextField"
                                                    onChange={props.handleChange}
                                                    onBlur={(e) => (handleLastName(e))}
                                                    value={props.values.loan_officer_info.last_name?.trimStart()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-res-50 py-2">
                                        <div className="pb-2">
                                            <h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Email Address</h6>
                                        </div>
                                        <div>
                                            <TextField
                                                type="email"
                                                id="customer_email"
                                                variant="outlined"
                                                name="loan_officer_info.email"
                                                className="form-TextField"
                                                onChange={handleEmail, props.handleChange}
                                                value={props.values.loan_officer_info.email?.trimStart()}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-res-50 py-2">
                                        <div className="pb-2">
                                            <h6 className="m-0" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-semibold"}:{}}>Phone Number</h6>
                                        </div>
                                        <div>
                                            <div className="d-flex align-items-center" id="emailId">
                                                <div className="px-2 border rounded" style={{ height: '56px', padding: '17.5px 14px' }}>+1</div>
                                                <NumberFormat
                                                    id="phoneNumber"
                                                    className="phonenumber-field"
                                                    format=" (###) ###-####"
                                                    onChange={(e) => phoneNumberFormat(e)}
                                                    onFocus={props.handleChange}
                                                    name="loan_officer_info.phone_number"
                                                    value={props.values.loan_officer_info.phone_number}
                                                    allowEmptyFormatting />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        :""}
                    </div>
                    : ''}
                {props.validateDisplay6 === true ? props.errors.loan_officer ?
                    <div className="error-msg" style={props?.partner?.url_path === "c2" ? { fontFamily:"FTPolar-Light"}:{}}>{props.errors.loan_officer}</div> : ''
                    : ''}
            </div>
        </div>
    )
}